import PropTypes from 'prop-types'

import { TpmsObjectClasses } from '../../models/tpms/tpms-object-classes-enum'
import { tpmsAxlePropType } from './tpms-axle-prop-type'

/**
 * @typedef {Object} TpmsChassis
 * @property {Array<TpmsAxle>} axles
 * @property {string} objectClass
 * @property {string} objectId
 */
export const tpmsChassisPropType = PropTypes.shape({
    axles: PropTypes.arrayOf(tpmsAxlePropType),
    objectClass: PropTypes.oneOf(Object.values(TpmsObjectClasses)),
    objectId: PropTypes.string
})
